import { catchError, finalize, tap } from "rxjs/operators";
import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";

import { ToastService } from "./toast.service";
import { LoaderService } from "./loader.service";
import { Router } from "@angular/router";
import { AuthService } from "app/modules/api";

@Injectable()
export class HttpsInterceptor implements HttpInterceptor {
  constructor(
    private ts: ToastService,
    private ls: LoaderService,
    private router: Router,
    private as: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    // Clone the request to add the new header.
    const authReq = req.clone({
      headers: new HttpHeaders({
        Authorization: currentUser ? `Bearer ${currentUser.token}` : ``,
      }),
    });

    // console.log('Sending request with new header now ...');

    // send the newly created request
    this.ls.display(true);
    return next.handle(authReq).pipe(
      // tap(
      //     response => {
      //         if (response.type === 4) {
      //             setTimeout(() => {
      //                this.ls.display(false);
      //                this.ls.optional(true);
      //             }, 1500);
      //         }
      //     },
      //     error => {
      //         console.log("error", error);
      //         if (error.status === 401) {
      //             alert('Your session is expired. Please login again');
      //             localStorage.removeItem('currentUser');
      //             this.router.navigate(['/login']);
      //         }
      //         this.ts.showError(error.headers.get('status'));
      //         setTimeout(() => {
      //             this.ls.display(false);
      //             this.ls.optional(true);
      //         }, 1500);
      //     },
      // )
      catchError((error: HttpErrorResponse) => {
        console.log(error);
        if (error.status === 401) {
          localStorage.clear();
          this.as.apiAuthsLogoutDelete().subscribe();
          location.href = "/login";
          // Handle 401 error
          console.error("Unauthorized request. Redirecting to login...");
          // Perform actions like redirecting to login or refreshing token
        }
        return throwError(() => error); // Re-throw the error for other handlers
      })
    );
    /* .catch ((error, caught) => {
        // intercept the respons error and displace it to the console
        this.ts.showError(error.headers.get('status'));
        console.log(error);
        // return the error to the method that called it
        return Observable.throw(error);
    }) as any; */
  }
}
